import { Component, inject } from '@angular/core';
import { PortalContextService } from '../../../core/auth/portal-context.service';
import { AdminLogin } from '../admin-login/admin-login';
import { FranchiseLogin } from '../franchise-login/franchise-login';
import { Login } from '../login/login';

@Component({
  selector: 'app-portal-login',
  standalone: true,
  imports: [AdminLogin, Login, FranchiseLogin],
  template: `
    @switch (portal.portal) {
      @case ('admin') { <app-admin-login /> }
      @case ('franchise') { <app-franchise-login /> }
      @default { <app-login /> }
    }
  `,
})
export class PortalLogin {
  readonly portal = inject(PortalContextService);
}
